import React from "react";

// components
import NewTag from "ClassRoom/components/AddAssignment/LessonPlanningAssistant/components/NewTag";

// design system
import { StarsTwoFilled } from "@toddle-edu/ds-icons";

// third party
import classNames from "classnames";

// utils
import { getHighlightedText } from "Utils/StringHelpers";

// scss
import classes from "./Prompt.scss";

const Prompt = props => {
  const {
    t,
    prompt,
    uniqueKey,
    selectedPrompt,
    setSelectedPrompt,
    searchText,
  } = props;

  const { label, isNewTagVisible = false } = prompt;

  const isSelected = selectedPrompt?.uniqueKey === uniqueKey;

  const onPromptClick = selectedPromptId => {
    if (selectedPromptId === uniqueKey) {
      // if already selected then deselect else select
      if (selectedPrompt?.uniqueKey === uniqueKey) {
        setSelectedPrompt({});
      } else {
        setSelectedPrompt({ ...prompt, uniqueKey });
      }
    } else {
      setSelectedPrompt({});
    }
  };

  // classes
  const promptContainerClass = classNames({
    [classes.promptContainer]: true,
    [classes.selectedPromptContainer]: isSelected,
  });

  const displayTextClass = classNames("text-body-2", classes.displayText, {
    [classes.selectedDisplayText]: isSelected,
  });

  const highlightedLabel = getHighlightedText({ label, searchText });

  return (
    <div
      key={uniqueKey}
      className={promptContainerClass}
      onClick={() => onPromptClick(uniqueKey)}
      onKeyDown={e =>
        (e.key === "Enter" || e.key === " ") && onPromptClick(uniqueKey)
      }
      tabIndex={0}
      aria-label="prompt"
      role="button"
    >
      <StarsTwoFilled variant={isSelected ? "link" : "subtle"} />
      <div className={classes.promptRightContainer}>
        <div className={displayTextClass}>
          <div>{highlightedLabel}</div>
          <NewTag t={t} isNewTagVisible={isNewTagVisible} />
        </div>
      </div>
    </div>
  );
};

export default Prompt;
